import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptTypeUpdateStore } from "../../store";
import { PaymentReceiptTypeUpdateForm } from "./PaymentReceiptTypeUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type PaymentReceiptTypeUpdateProps = {
  paymentReceiptTypeUpdateStore: PaymentReceiptTypeUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PaymentReceiptTypeUpdate: React.FC<PaymentReceiptTypeUpdateProps> =
  observer(
    ({ paymentReceiptTypeUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={paymentReceiptTypeUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={paymentReceiptTypeUpdateStore.savedButOutdated}
            onReload={() =>
              paymentReceiptTypeUpdateStore.reloadPaymentReceiptType()
            }
            reloadDisabled={paymentReceiptTypeUpdateStore.isProcessing}
          />
          <PaymentReceiptTypeUpdateForm
            paymentReceiptTypeUpdateStore={paymentReceiptTypeUpdateStore}
            name_esError={paymentReceiptTypeUpdateStore.errors.name_es?.message}
            onName_esChange={(value: string) => {
              paymentReceiptTypeUpdateStore.setName_esValue(value);
            }}
            name_es={paymentReceiptTypeUpdateStore.entityValues.name_es}
            name_enError={paymentReceiptTypeUpdateStore.errors.name_en?.message}
            onName_enChange={(value: string) => {
              paymentReceiptTypeUpdateStore.setName_enValue(value);
            }}
            name_en={paymentReceiptTypeUpdateStore.entityValues.name_en}
            name_ptError={paymentReceiptTypeUpdateStore.errors.name_pt?.message}
            onName_ptChange={(value: string) => {
              paymentReceiptTypeUpdateStore.setName_ptValue(value);
            }}
            name_pt={paymentReceiptTypeUpdateStore.entityValues.name_pt}
            priceError={paymentReceiptTypeUpdateStore.errors.price?.message}
            onPriceChange={(value: number) => {
              paymentReceiptTypeUpdateStore.setPriceValue(value);
            }}
            price={paymentReceiptTypeUpdateStore.entityValues.price}
            currencyError={
              paymentReceiptTypeUpdateStore.errors.currency?.message
            }
            onCurrencyChange={(value) => {
              paymentReceiptTypeUpdateStore.setCurrencyValue(value);
            }}
            currencySelectedValue={
              paymentReceiptTypeUpdateStore.entityValues.showCurrency
            }
            onCurrencySelected={(value) => {
              paymentReceiptTypeUpdateStore.setSelectedCurrency(value);
            }}
            currencyOptions={paymentReceiptTypeUpdateStore.getCurrencyOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={paymentReceiptTypeUpdateStore.saveDisabled}
            onSave={() =>
              paymentReceiptTypeUpdateStore.savePaymentReceiptType()
            }
            onCancel={() =>
              paymentReceiptTypeUpdateStore.cancelPaymentReceiptType()
            }
          />
          <ErrorDialog
            open={paymentReceiptTypeUpdateStore.errorDialogOpened}
            title={paymentReceiptTypeUpdateStore.errorTitle}
            description={paymentReceiptTypeUpdateStore.errorDescription}
            onClose={() => paymentReceiptTypeUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={paymentReceiptTypeUpdateStore.confirmDialogOpened}
            title={paymentReceiptTypeUpdateStore.confirmDialogTitle}
            description={paymentReceiptTypeUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              paymentReceiptTypeUpdateStore.executeConfirmedAction()
            }
            onCancel={() => paymentReceiptTypeUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
